/**
 * 运行状态
 */
export const syncStatusE = {
    Unsynchronized: {
        value: '0',
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_HyperCopy_NOTSYNCHRONIZED',
    },
    Synchronizing: {
        value: '1',
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_HyperCopy_SYNCHRONIZING',
    },
    Normal: {
        value: '2',
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_HyperCopy_NORMAL',
    },
    SyncPaused: {
        value: '3',
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_HyperCopy_SYNCHRONIZED_PAUSE',
    },
    FullCopyRestoring: {
        value: '4',
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_HyperCopy_FULLREVERSESYNING',
    },
    DiffCopyRestoring: {
        value: '5',
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_HyperCopy_DIFREVERSESYNING',
    },
    FullCopyRestorationPaused: {
        value: '6',
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_HyperCopy_FULLREVERSESYN_PAUSE',
    },
    DiffCopyRestorationPaused: {
        value: '7',
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_HyperCopy_DIFREVERSESYN_PAUSE',
    },
    Initializing: {
        value: '8',
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_HyperCopy_INITIALIZING',
    },
    Deleting: {
        value: '9',
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_HyperCopy_DELETING',
    },
};

/**
 * 同步动作枚举
 */
export enum actionE {
    start = 0,
    pause = 1,
    resume = 3,
    stop = 2
}
